import React from 'react';

var ArrowTop = function ArrowTop(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 12.414l6.293 6.293a1 1 0 0 0 1.414-1.414l-7-7a1 1 0 0 0-1.414 0l-7 7a1 1 0 0 0 1.414 1.414L12 12.414zM6 6a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm14 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0zM5 7h14V5H5v2z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

ArrowTop.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { ArrowTop as icon };
export default iconHandler(ArrowTop);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/ArrowTop.js
// module id = 582
// module chunks = 0